import {
  Component,
  OnInit,
  ChangeDetectorRef,
  SecurityContext,
} from "@angular/core";
import { FormsModule } from "@angular/forms";
import { AuthService } from "../auth.service";
import { Router } from "@angular/router";
import { DomSanitizer } from "@angular/platform-browser";
import { Empleado } from "src/app/shared/model/empleado/empleado.model";
import { EmpleadoService } from "src/app/empleado/empleado.service";
import swal from "sweetalert2";
import { CommonModule } from "@angular/common";
import { MatIconModule } from "@angular/material/icon";
import { MatButtonModule } from "@angular/material/button";
import { MatSlideToggle } from "@angular/material/slide-toggle";
import { SelectorTemaComponent } from "src/app/shared/tema/selector-tema.component";
import { PinAutorizadorPanelComponent } from "../pin-autorizador/pin-autorizador-panel.component";
import { Constantes } from "src/app/utilerias/constantes/constantes";

@Component({
    selector: "app-wizard-cmp",
    standalone: true,
    templateUrl: "ajustes-usuario.component.html",
    imports: [
      FormsModule,
      CommonModule,
      MatIconModule,
      MatButtonModule,
      MatSlideToggle,
      SelectorTemaComponent,
      PinAutorizadorPanelComponent,
    ],
})
export class WizardComponent implements OnInit {
  pNombre: string;
  correoelectronico: string;
  gitSet: string;
  azureSet: string;
  puestoActual = "Colaborador SOLSER";
  areaActual = "Sin área asignada";
  gitConfigurado = false;
  azureConfigurado = false;
  gitTokenPreview = "Sin token configurado";
  azureTokenPreview = "Sin token configurado";
  recibirCorreo: boolean = false;
  fotoajustes: any;
  nombreusuario: string;
  selectedFile: File | null = null;

  constructor(
    private authS: AuthService,
    private router: Router,
    private sanitizer: DomSanitizer,
    private emp: EmpleadoService,
    private cdr: ChangeDetectorRef,
  ) {}

  ngOnInit() {
    this.fotoajustes = "./assets/img/default-avatar.png";
    this.personaajustes();
  }

  editpassword() {
    this.router.navigate(["admin/password"]);
  }

  edittoken() {
    this.router.navigate(["admin/tokens"]);
  }

  // foto de persona ajustes
  personaajustes() {
    this.authS.getSesion().subscribe((res) => {
      if (!res) {
        return;
      }

      this.pNombre = res.persona.nombreCompleto;
      this.correoelectronico = res.persona.correoelectronico;
      this.nombreusuario = res.usuario.user_nom;
      this.puestoActual = res.datos?.puesto?.puesto || "Colaborador SOLSER";
      const areaActual = res.datos?.area?.area ?? res.datos?.area_empleado;
      this.areaActual = areaActual ? String(areaActual) : "Sin área asignada";
      this.gitConfigurado = !!res.usuario.token_personal;
      this.azureConfigurado = !!res.usuario.token_azure;
      this.gitSet = this.gitConfigurado ? "Conectado" : "Pendiente";
      this.azureSet = this.azureConfigurado ? "Sincronizado" : "Pendiente";
      this.gitTokenPreview = this.maskToken(res.usuario.token_personal);
      this.azureTokenPreview = this.maskToken(res.usuario.token_azure);
      this.recibirCorreo = res.datos?.recibirCorreo == 1;
      this.cdr.detectChanges();

      this.authS.consultpersonfoto(0).subscribe({
        next: (res: any) => {
        let arreglo = new Uint8Array(res);
        let imgtxt: string = "";
        new Uint8Array(arreglo).forEach(function (byte: number) {
          imgtxt += String.fromCodePoint(byte);
        });
        let base64Img = btoa(imgtxt);
        /*let arreglo = new Uint8Array(res);
            const imgTxt = String.fromCharCode.apply(null, arreglo);
            let base64Img = btoa(imgTxt);*/
        // Por el saneador de Angular, no saltándolo: con el prefijo data:image fijo la deja pasar tal cual.
        this.fotoajustes = this.sanitizer.sanitize(
          SecurityContext.URL,
          "data:image/jpg;base64," + base64Img
        );
          this.cdr.detectChanges();
        },
        error: () => {
          this.fotoajustes = "./assets/img/default-avatar.png";
          this.cdr.detectChanges();
        },
      });
    });
  }

  onFileChanged(event: Event) {
    const input = event.target as HTMLInputElement;
    const archivo = input.files?.[0];
    // Se limpia para que volver a elegir el mismo archivo dispare otro change.
    input.value = "";
    if (!archivo) {
      return;
    }

    this.selectedFile = archivo;
    const formData = new FormData();
    formData.append("file", archivo, archivo.name);
    // La foto nueva se pinta hasta que el servidor confirma. Antes se pintaba
    // al elegir el archivo aunque la subida fallara, y al volver a entrar ya
    // no estaba.
    this.authS.uploadPersonFoto(formData).subscribe({
      next: (res) => {
        if (res?.pCodRetorno !== Constantes.EXITO) {
          this.avisarFotoNoGuardada(res?.pMensaje);
          return;
        }
        const reader = new FileReader();
        reader.onload = () => {
          this.fotoajustes = reader.result;
          this.authS.changeFotoPerfil(String(reader.result));
          this.cdr.detectChanges();
        };
        reader.readAsDataURL(archivo);
      },
      error: () => this.avisarFotoNoGuardada(),
    });
  }

  private avisarFotoNoGuardada(mensaje?: string) {
    swal.fire({
      title: "No se guardó la foto",
      text: mensaje?.trim() || "Intenta de nuevo con una imagen jpg o png.",
      icon: "error",
      buttonsStyling: false,
      customClass: { confirmButton: "btn btn-success" },
      confirmButtonText: "Aceptar",
    });
  }

  editemail() {
    this.router.navigate(["admin/datospersonales"]);
  }

  actulizarEstatusEnvioCorreo(check: any): void {
      const operacion = (!this.recibirCorreo) ? "Dejar de recibir correos de notificación" : "Recibir notificación por correo";

      swal.fire({
        title: operacion,
        text: "¿Está seguro de actualizar el estatus de envío de correo notificaciones?",
        buttonsStyling: false,
        icon: "warning",
        confirmButtonText: "Aceptar",
        customClass:{
          confirmButton: 'btn btn-success',
          cancelButton: 'btn btn-info',
        },
        cancelButtonText: "Cancelar",
        showConfirmButton: true,
        showCancelButton: true,
      }).then((actualizar)=>{
        if(actualizar.value){
          const empleadoObj: Empleado = new Empleado();
          empleadoObj.recibirCorreo = (this.recibirCorreo )?  1:0;
          this.emp.actualizaCorreoNotificacion(empleadoObj).subscribe();
        } else {
          this.recibirCorreo = !this.recibirCorreo;
          check.source.checked = this.recibirCorreo;
          this.cdr.detectChanges();
        }
      });
  }

  private maskToken(token?: string | null): string {
    if (!token || token.trim() === "") {
      return "Sin token configurado";
    }

    const safeToken = token.trim();
    const lastChars = safeToken.slice(-4);
    return `${"•".repeat(Math.max(safeToken.length - 4, 8))}${lastChars}`;
  }
}
